import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'

import OmsattMatrikkelenhet from './OmsattMatrikkelenhet.jsx'
import CollapseIcon from '../../../images/expand copy 7.png'
import ExpandIcon from '../../../images/collapse copy 7.png'

class OmsattMatrikkelenhetList extends Component {
    state = {
        isOpened: false,
        continuationToken: null        
    }

    toggleOmsatteMatrikkelenheter = () => {
        if (this.props.antall == 0) return
        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        return (
            <li>
                <div className="section-header" onClick={this.toggleOmsatteMatrikkelenheter}>
                    { !this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw"></i></span>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('omsattematrikkelenheter')} ({this.props.omsatte.length})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.props.omsatte.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.props.omsatte.map((o, index) => {return (<OmsattMatrikkelenhet key={o.matrikkelenhetId} matrikkelenhet={o} antall={this.props.omsatte.length} isLast={index==this.props.omsatte.length-1} />)}) }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(OmsattMatrikkelenhetList)